import { render, staticRenderFns } from "./topicSummary.vue?vue&type=template&id=1dea2184&scoped=true&"
import script from "./topicSummary.vue?vue&type=script&lang=js&"
export * from "./topicSummary.vue?vue&type=script&lang=js&"
import style0 from "./topicSummary.vue?vue&type=style&index=0&id=1dea2184&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dea2184",
  null
  
)

export default component.exports